import { APIS, URLS } from '@/shared/config/urls';
import type { ApiResponse } from '@/shared/types/abstract-api-response';
import type { RoadData, RoadDetail } from '@/shared/types/types-road-management';
import { request } from '@/shared/utils/request';

// [GET] Road List with Side Id
export const fetchRoadList: (params: string) => Promise<ApiResponse<RoadDetail[]>> = async (
  params = ''
) => {
  const url = `${URLS.BACK_DSH}${APIS.roadList(params)}`;
  return await request.get(url);
};

// [GET] Detail Road Stream URL Info With Road Id
export const fetchDetailRoadStream: (roadId: number) => Promise<ApiResponse<string>> = async (
  roadId
) => {
  const url = `${URLS.BACK_DSH}${APIS.detailRoadStreamURL(roadId)}`;
  return await request.get(url);
};

// [DELETE] Delete Road
export const deleteRoad: (roadId: number) => Promise<ApiResponse<{ road_id: number }>> = async (
  roadId
) => {
  const url = `${URLS.BACK_DSH}${APIS.deleteRoad(roadId)}`;
  return await request.delete(url);
};

// [POST] Create Road
export const createRoad: (roadData: RoadData) => Promise<ApiResponse<{ road_id: number }>> = async (
  roadData
) => {
  const url = `${URLS.BACK_DSH}${APIS.createRoad}`;
  return await request.post(url, roadData);
};

// [PUT] Update Road
export const updateRoad: (roadId: number, roadData: RoadData) => Promise<ApiResponse<null>> =
  async (roadId, roadData) => {
    console.log('updateRoad(road-mgt)');
    console.log(roadId);
    console.log(roadData);

    const url = `${URLS.BACK_DSH}${APIS.updateRoad(roadId)}`;
    return await request.put(url, roadData);
  };
